import { useCallback, useState } from 'react';

const STORAGE_KEY = 'bao_dismissed_alerts';

type DismissedAlerts = Record<string, string>; // { [publicId]: expirationDatetimeUtc }

function loadAndClean(): DismissedAlerts {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const stored: DismissedAlerts = raw ? JSON.parse(raw) : {};
    const now = new Date();

    const cleaned = Object.fromEntries(Object.entries(stored).filter(([, expiresAt]) => new Date(expiresAt) > now));

    localStorage.setItem(STORAGE_KEY, JSON.stringify(cleaned));
    return cleaned;
  } catch {
    return {};
  }
}

function useDismissedAlerts() {
  const [dismissed, setDismissed] = useState<DismissedAlerts>(loadAndClean);

  const dismiss = useCallback((publicId: string, expirationDatetimeUtc: string) => {
    setDismissed(prev => {
      const updated = { ...prev, [publicId]: expirationDatetimeUtc };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const isDismissed = useCallback((publicId: string) => publicId in dismissed, [dismissed]);

  return { dismiss, isDismissed };
}

export default useDismissedAlerts;
